import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/CollageGame/scenes/GameIntro';

interface PhaserCollageGameProps {
    onComplete: () => void;
}

interface PhaserCollageGameState {
}

const gameConfig: GameConfig = {
    title: "Collage Game",
    version: "0.9.3",
    backgroundColor: "#000000",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
        }
    },
};

class PhaserCollageGame extends React.Component<PhaserCollageGameProps, PhaserCollageGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserCollageGameProps) {
        super(props);
        bindAllOfThis(this, PhaserCollageGame.prototype);
    }

    // This game is different than the others, it has an interview before the HowToPlayScene and game
    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserCollageGame;



// WEBPACK FOOTER //
// ./src/games/CollageGame/Main.tsx